<script setup>
import { ref, watch } from 'vue';
import BaseDialog from './BaseDialog.vue';
import useAlertStore from '@/stores/alert';

const alertStore = useAlertStore();
const showDialog = ref(false);
const message = ref('');
const options = ref([]);
const defaultOptions = ref([
    {
        value: 'Ok',
        color: 'primary',
        action: () => {}
    }
]);

watch(
    () => alertStore.messages,
    async (alerts) => {
        if (alertStore.promise !== null) {
            return;
        }

        while (alerts.length > 0) {
            const alert = alerts.shift();
            await alertStore.show(alert.message, alert.buttons);
        }
    },
    { deep: true, immediate: true }
);

watch(
    () => alertStore.message,
    (value) => {
        if (value) {
            message.value = value;
            showDialog.value = true;

            options.value =
                alertStore.buttons.length > 0
                    ? alertStore.buttons
                    : defaultOptions.value;
        } else {
            showDialog.value = false;
        }
    }
);

const onOptionsPressed = async (btnPressed) => {
    btnPressed.loading = true;
    if (btnPressed.action) {
        await btnPressed.action();
    }

    btnPressed.loading = false;
    alertStore.close();
};
</script>

<template>
    <BaseDialog
        :showDialog="showDialog"
        :message="message"
        :icon="`mdi-help-circle-outline`"
        :options="options"
        @optionPressed="onOptionsPressed"
    />
</template>
